import React from "react"

import { Link } from "components/anti/link/link"
import { useScrollAnim } from "src/components/hooks/hooks"


export const InvestorQuickAccess = ({ data }) => {
    const [trigger, anim] = useScrollAnim()

    return (
        <section className="py-main sc-investor-quickAccess" ref={trigger}>
            <div className="container">
                <h2 className={`mb-4 ${anim(1)}`}>{data.title}</h2>
                <div className="row row-4 px-3">
                    {data.list.map((access, i) => {
                        return (
                            <div className={`col-md-4 mb-4 ${anim(2 + i)}`} key={i}>
                                <Link to={access.url} target={null} className="quickAccess-link">
                                    <div className="row">
                                        <div className="col-2 col-md-4 col-lg-2 px-0">
                                            <img src={access.icon.sourceUrl} className="img-fluid h-50px" alt="icon" />
                                        </div>
                                        <div className="col-10 col-md-8 col-lg-10 d-flex align-items-center">
                                            <p className="mb-0 mr-5 font-weight-bold">{access.text}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}